import { articlePriceChanges } from './articlePricing';

export function articleEditChanges(key, value, current, excluded = []) {
  const patch = articlePriceChanges(key, value, current, excluded);
  if (key === 'code_fam' && value !== current.code_fam) patch.code_sfam = null;
  return patch;
}
